import React from 'react';

import {
    AccordionPanel,
    List,
} from 'reaxl';

import SubSectionHeader from './SubSectionHeader';

const psxVerify = {
    heading: 'What does Verified mean, and how does it protect me as a buyer?',
    description: 'Before a vehicle sale can be completed through Private Seller Exchange (“PSX” or “we”), we confirm many important details about the car, its history, and who owns it. We perform this multi-point evaluation for the benefit and protection of both buyers and sellers using our marketplace in good faith.',
    subheading: 'Our process of verifying a listing includes the following steps:',
    steps: [
        {
            title: 'Ensure whether the seller is the registered owner',
            description: 'We confirm whether the person listing the car for sale is the legal owner of that car. If we determine that the car is owned or co-owned by someone else, we may require additional proof of the right to sell it.',
        },
        {
            title: 'Evaluation of VIN and vehicle history report',
            description: 'We flag it if a car listed using Private Seller Exchange has a \'branded\' or \'salvage\' title. These are cars that may have undergone significant damage at some point in their history, through events like a collision, a flood, or hail.',
            conclusion: 'A car that has been stolen and later recovered also might have a branded title. A car with damage extensive enough to warrant a branded/salvage title does not meet our quality standards, and will not be permitted to be financed or transacted through our platform.',
        },
        {
            title: 'Resolving liens and loans',
            description: 'We flag it if a car listed using Private Seller Exchange is leased. A leased vehicle will not be permitted to be financed or transacted through our platform until seller exercised the right to buy it free and clear from the lessor.',
            conclusion: 'If the vehicle is subject to an outstanding loan or other lien, we verify the payoff amount required to remove the lien, and arrange for outstanding liens to be paid off and delivered to buyer with a clear title.',
        },
        {
            title: 'Safety Attestation by Seller',
            description: 'In order for a vehicle to be sold through Private Seller Exchange, each seller must attest that:',
            conclusion: 'Please note, however, that the above attestations are not independently verified by PSX. ',
            attestationSteps: [
                'The windshield is free of major obstructions, large cracks or significant damage.',
                'Tires are in good condition and an acceptable minimum tread depth for safe operation.',
                'Seatbelts are present, functioning properly, and undamaged.',
                'Headlights, brake lights, turn signals, and reverse lights are all working properly, and that all lenses are intact.',
            ],
        },
    ],
};

function PsxVerify() {
    const { heading, description, subheading, steps } = psxVerify;
    const getAttestationSteps = (items = []) => (items.length > 0 ? (
        <List
            items={items}
            className="margin-vertical-2 padding-left-0 margin-left-4"
        />
    ) : '');

    return (
        <AccordionPanel
            title="What Does PSX Verify?"
            key="verification"
            eventKey="verification"
        >
            <SubSectionHeader
                heading={heading}
                description={description}
                footer={subheading}
            />
            {steps.map(({ title, description: stepDescription, conclusion, attestationSteps }) => (
                <SubSectionHeader
                    heading={title}
                    description={stepDescription}
                    footer={conclusion}
                    glyph="check-circle"
                    key={title}
                >
                    {getAttestationSteps(attestationSteps)}
                </SubSectionHeader>
            ))}
        </AccordionPanel>
    );
}
export default React.memo(PsxVerify);
